/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRazorElectric = createReactComponent("razor-electric", "IconRazorElectric", [
  ["path", { d: "M8 3v2", key: "svg-0" }],
  ["path", { d: "M12 3v2", key: "svg-1" }],
  ["path", { d: "M16 3v2", key: "svg-2" }],
  ["path", { d: "M9 12v6a3 3 0 0 0 6 0v-6h-6z", key: "svg-3" }],
  ["path", { d: "M8 5h8l-1 4h-6z", key: "svg-4" }],
  ["path", { d: "M12 17v1", key: "svg-5" }]
]);

export { IconRazorElectric as default };
//# sourceMappingURL=IconRazorElectric.js.map
